import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { ITEM_PRICE_LIST_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getItemPriceListsAction = createAsyncThunk(
    'price/getItemPriceListsAction',
    async (productId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ ITEM_PRICE_LIST_PATH }/${ productId }/price-list`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getItemPriceListsSlice = createSlice({
    name: 'getItemPriceListsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getItemPriceListsAction.pending, () => STATE__API__STARTED);
        builder.addCase(getItemPriceListsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getItemPriceListsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getItemPriceListsState = (state) => state.price.getItemPriceLists;
export default getItemPriceListsSlice.reducer;
